module.exports = __webpack_public_path__ + "static/media/tick.1ff6eadf.svg";